<template>
  <span>
    <el-button type='primary' @click='showFilterSetDialogMD' icon='sys sys-filter-set' class='navbarbtn'> 滤 设</el-button>

    <el-dialog v-dialogDrag title='用户过滤设置' :visible.sync='showFilterSetDialogInner' width='75%' top='10px' lock-scroll
      append-to-body>
      <div class='hbox'>
        <el-table :data='filterInfo' border height='400px' v-loading='filterSetLoading'
          :cell-style='tableCellStyle' :header-cell-style='tableHeaderCellStyle' size='medium'
          style='margin-top: -20px;'>
          <el-table-column type='index' label='序号' header-align='center' align='center' width='60' fixed></el-table-column>
          <el-table-column prop='ColumnCode' label='列名称' width='160' fixed>
            <template #header>
              <span style='color: blue;'>列名称</span>
            </template>
            <template #default='scope'>
              <select class='tableInput' v-model='scope.row.ColumnCode' style='width: 140px;'
                @change='filterColumnChange(scope)'>
                <option v-for='column in columnInfo' :key='column.ColumnCode' :value='column.ColumnCode'>{{column.ColumnName}}</option>
              </select>
            </template>
          </el-table-column>
          <el-table-column prop='FilterType' label='过滤类型' width='100'>
            <template #header>
              <span style='color: blue;'>过滤类型</span>
            </template>
            <template #default='scope'>
              <select class='tableInput' v-if='scope.row.DataType === "0"' v-model='scope.row.FilterType' style='width: 80px;'>
                <option v-for='filterType in filterTypes0' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
              </select>
              <select class='tableInput' v-if='scope.row.DataType === "1"' v-model='scope.row.FilterType' style='width: 80px;'>
                <option v-for='filterType in filterTypes1' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
              </select>
              <select class='tableInput' v-if='scope.row.DataType === "2"' v-model='scope.row.FilterType' style='width: 80px;'>
                <option v-for='filterType in filterTypes2' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
              </select>
              <select class='tableInput' v-if='scope.row.DataType === "3"' v-model='scope.row.FilterType' style='width: 80px;'>
                <option v-for='filterType in filterTypes3' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
              </select>
              <select class='tableInput' v-if='scope.row.DataType === "4"' v-model='scope.row.FilterType' style='width: 80px;'>
                <option v-for='filterType in filterTypes4' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
              </select>
              <select class='tableInput' v-if='scope.row.DataType === "5"' v-model='scope.row.FilterType' style='width: 80px;'>
                <option v-for='filterType in filterTypes5' :key='filterType.code' :value='filterType.code'>{{filterType.name}}</option>
              </select>
            </template>
          </el-table-column>
          <el-table-column prop='Type' label='条件类型' width='80'>
            <template #header>
              <span style='color: blue;'>条件类型</span>
            </template>
            <template #default='scope'>
              <select class='tableInput' v-model='scope.row.Type' style='width: 60px;'>
                <option v-for='type in types' :key='type.code' :value='type.code'>{{type.name}}</option>
              </select>
            </template>
          </el-table-column>
          <el-table-column prop='DataType' label='数据类型' width='100'>
            <template #default='scope'>
              <span>{{filterSpecialStringDisplayTransform(scope.row.DataType, 'DataType')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop='OutDisplay' label='外部显示' width='80'>
            <template #header>
              <span style='color: blue;'>外部显示</span>
            </template>
            <template #default='scope'>
              <select class='tableInput' v-model='scope.row.OutDisplay' style='width: 60px;'>
                <option v-for='outDisplay in outDisplays' :key='outDisplay.code' :value='outDisplay.code'>{{outDisplay.name}}</option>
              </select>
            </template>
          </el-table-column>
          <el-table-column prop='DateFormat' label='日期格式' width='140'>
            <template #header>
              <span style='color: blue;'>日期格式</span>
            </template>
            <template #default='scope'>
              <select class='tableInput' v-if='scope.row.DataType === "4"' v-model='scope.row.DateFormat' style='width: 120px;'>
                <option v-for='dateFormat in dateFormats' :key='dateFormat.code' :value='dateFormat.code'>{{dateFormat.name}}</option>
              </select>
            </template>
          </el-table-column>
          <el-table-column prop='DefaultVal1Type' label='默认值1类型' width='100'>
            <template #header>
              <span style='color: blue;'>默认值1类型</span>
            </template>
            <template #default='scope'>
              <select class='tableInput' v-model='scope.row.DefaultVal1Type' style='width: 80px;'>
                <option v-for='defaultValType in defaultValTypes' :key='defaultValType.code' :value='defaultValType.code'>{{defaultValType.name}}</option>
              </select>
            </template>
          </el-table-column>
          <el-table-column prop='DefaultVal1' label='默认值1' width='140'>
            <template #header>
              <span style='color: blue;'>默认值1</span>
            </template>
            <template #default='scope'>
              <input v-if='scope.row.DefaultVal1Type === "0"' v-model='scope.row.DefaultVal1' style='width: 120px;' class='tableInput'/>
            </template>
          </el-table-column>
          <el-table-column prop='DefaultVal2Type' label='默认值2类型' width='100'>
            <template #header>
              <span style='color: blue;'>默认值2类型</span>
            </template>
            <template #default='scope'>
              <select class='tableInput' v-model='scope.row.DefaultVal2Type' style='width: 80px;'>
                <option v-for='defaultValType in defaultValTypes' :key='defaultValType.code' :value='defaultValType.code'>{{defaultValType.name}}</option>
              </select>
            </template>
          </el-table-column>
          <el-table-column prop='DefaultVal2' label='默认值2' width='140'>
            <template #header>
              <span style='color: blue;'>默认值2</span>
            </template>
            <template #default='scope'>
              <input v-if='scope.row.DefaultVal2Type === "0"' v-model='scope.row.DefaultVal2' style='width: 120px;' class='tableInput'/>
            </template>
          </el-table-column>

          <el-table-column label='操作' width='120' fixed='right'>
            <template #default='scope'>
              <el-tooltip effect='dark' content='删除该行' placement='top-start'>
                <el-button type='danger' circle style='padding: 4px;' @click='deleteOneFilter(scope.$index)'><i class='sys sys-delete'></i></el-button>
              </el-tooltip>
              <el-tooltip effect='dark' content='上移' placement='top-start'>
                <el-button type='primary' circle style='padding: 4px;' @click='upOneFilter(scope.$index)'><i class='sys sys-box-up'></i></el-button>
              </el-tooltip>
              <el-tooltip effect='dark' content='下移' placement='top-start'>
                <el-button type='primary' circle style='padding: 4px;' @click='downOneFilter(scope.$index)'><i class='sys sys-box-down'></i></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class='dialogButtomBtn'>
        <el-button type='primary' @click='addOneFilter()' size='mini'>添加行</el-button>
        <el-button type='warning' @click='returnDefaultTableFilter()' size='mini'>恢复默认</el-button>
        <el-button type='primary' @click='saveUserTableFilter()' size='mini'>保存</el-button>
        <el-button @click='updateUserFilterDialogReset()' size='mini'>重置</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import code from '@/components/sys/Code'
import table from '@/components/sys/Table'
import tableFilterSet from '@/components/sys/TableFilterSet'

export default {
  name: 'TableFilterSet',
  props: {
    filterInfo: {
      default: function () {
        return []
      },
      type: Array
    },
    columnInfo: {
      default: function () {
        return []
      },
      type: Array
    },
    showFilterSetDialog: {
      default: false,
      type: Boolean
    },
    changeShowFilterSetDialog: {
      default: false,
      type: Boolean
    },
    filterSetLoading: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    if (that.dataTypes.length <= 0) {
      const codes = that.codes
      that.dataTypes = code.getCode(codes, 'SYS_TableFilter_DataType')
      that.types = code.getCode(codes, 'SYS_TableFilter_Type')
      that.defaultValTypes = code.getCode(codes, 'SYS_TableFilter_DefaultValType')
      that.outDisplays = code.getCode(codes, 'SYS_TableFilter_OutDisplay')
      that.filterTypes0 = code.getCode(codes, 'SYS_TableFilter_FilterType0')
      that.filterTypes1 = code.getCode(codes, 'SYS_TableFilter_FilterType1')
      that.filterTypes2 = code.getCode(codes, 'SYS_TableFilter_FilterType2')
      that.filterTypes3 = code.getCode(codes, 'SYS_TableFilter_FilterType3')
      that.filterTypes4 = code.getCode(codes, 'SYS_TableFilter_FilterType4')
      that.filterTypes5 = code.getCode(codes, 'SYS_TableFilter_FilterType5')
      that.dateFormats = code.getCode(codes, 'SYS_TableFilter_DateFormat')
    }
  },

  data: function () {
    return {
      showFilterSetDialogInner: false,
      dataTypes: [],
      types: [],
      defaultValTypes: [],
      outDisplays: [],
      dateFormats: [],
      filterTypes0: [],
      filterTypes1: [],
      filterTypes2: [],
      filterTypes3: [],
      filterTypes4: [],
      filterTypes5: []
    }
  },

  watch: {
    showFilterSetDialog: function (newVal, oldVal) {
      const that = this
      that.showFilterSetDialogInner = newVal
    },
    changeShowFilterSetDialog: function (newVal, oldVal) {
      const that = this
      that.showFilterSetDialogInner = that.$props.showFilterSetDialog
    }
  },

  methods: {
    showFilterSetDialogMD: function () {
      this.$emit('showFilterSetDialogMD')
    },

    addOneFilter: function () {
      tableFilterSet.addOneFilter(this.$props.filterInfo)
    },

    deleteOneFilter: function (index) {
      tableFilterSet.deleteOneFilter(this.$props.filterInfo, index)
    },

    upOneFilter: function (index) {
      if (index === 0) return
      const that = this
      that.$props.filterInfo[index - 1] = [that.$props.filterInfo[index], that.$props.filterInfo[index] = that.$props.filterInfo[index - 1]][0]
      that.$props.filterInfo.splice(0, 0)
    },

    downOneFilter: function (index) {
      const that = this
      if (index === that.$props.filterInfo.length - 1) return
      that.$props.filterInfo[index] = [that.$props.filterInfo[index + 1], that.$props.filterInfo[index + 1] = that.$props.filterInfo[index]][0]
      that.$props.filterInfo.splice(0, 0)
    },

    filterColumnChange: function (scope) {
      tableFilterSet.filterColumnChange(scope, this.$props.columnInfo)
    },

    filterSpecialStringDisplayTransform: function (val, columnCode) {
      const that = this
      if (columnCode === 'DataType') {
        return table.specialStringDisplayTransform(val, that.dataTypes)
      }
    },

    returnDefaultTableFilter: function () {
      this.$emit('returnDefaultTableFilter')
    },

    updateUserFilterDialogReset: function () {
      this.$emit('updateUserFilterDialogReset')
    },

    saveUserTableFilter: function () {
      this.$emit('saveUserTableFilter')
    },

    tableCellStyle: function () {
      return { padding: '0px' }
    },

    tableHeaderCellStyle: function () {
      return { padding: '4px', 'background-color': '#f5f7fa' }
    }
  }
}
</script>

<style scoped>
.dialogButtomBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.tableInput {
  height: 20px;
  line-height: 20px;
  border: 0;
  background-color: transparent;
  padding: 0;
}
</style>
